import { ReactNode } from 'react';
import { Box, Switch } from '@mui/material';

interface Props {
  children: ReactNode;
  switchState: boolean;
  handleSwitchState: () => void;
}

const SwitchableInput = ({ children, switchState, handleSwitchState }: Props) => (
  <Box display="flex" justifyContent="space-between">
    {children}
    <Box display="flex" alignItems="center" mt="28px" ml={1} height="48px">
      <Switch onChange={handleSwitchState} checked={switchState} />
    </Box>
  </Box>
);

export default SwitchableInput;
